export function formatarParaMoedaBRL(valor: number): string {
    return !valor ? '' : valor.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }
   
  export function formatarCNPJ(cnpj: string): string {
    const clean = cnpj.replace(/[^A-Z0-9]/gi, '').toUpperCase();
   
    if (clean.length === 14) {
      return `${clean.slice(0, 2)}.${clean.slice(2, 5)}.${clean.slice(5, 8)}/${clean.slice(8, 12)}-${clean.slice(12)}`;
    }
   
    return cnpj;
  }
   
  export function formatarCPF(cpf: string): string {
    const apenasDigitos = cpf.replace(/\D/g, "");
   
    if (cpf.length === 14 && /\d{3}\.\d{3}\.\d{3}\-\d{2}/.test(cpf)) {
      return cpf;
    }
   
    if (apenasDigitos.length === 11) {
      return apenasDigitos.replace(
        /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
        "$1.$2.$3-$4"
      );
    }
   
    return cpf;
  }